import { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface ProgressBarProps {
  startLabel: string;
  startValue: number;
  endLabel: string;
  endValue: number;
  currentValue: number;
}

export const ProgressBar: FC<ProgressBarProps> = ({
  startLabel,
  startValue,
  endLabel,
  endValue,
  currentValue,
}) => {
  const progress =
    ((currentValue - startValue) / (endValue - startValue)) * 100;

  return (
    <Stack spacing={3} sx={{ width: '100%' }}>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="body2">{startLabel}</Typography>
        <Typography variant="body2">{endLabel}</Typography>
      </Stack>
      <Box
        sx={(theme) => ({
          height: 8,
          borderRadius: theme.shape.borderRadius,
          overflow: 'hidden',
          display: 'flex',
          gap: 1,
        })}
      >
        <Box
          sx={(theme) => ({
            width: `${progress}%`,
            background: `linear-gradient(90deg, ${theme.palette.warning.main} 0%, ${theme.palette.primary.main} 100%)`,
            borderRadius: theme.shape.borderRadius,
          })}
        />
        <Box
          sx={(theme) => ({
            width: `${100 - progress}%`,
            background: theme.palette.error.main,
            borderRadius: theme.shape.borderRadius,
          })}
        />
      </Box>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="body2">${startValue.toLocaleString()}</Typography>
        <Typography variant="body2">${endValue.toLocaleString()}</Typography>
      </Stack>
    </Stack>
  );
};
